module.exports = __webpack_public_path__ + "img/Screen01.2605cbea.svg";